import { render, staticRenderFns } from "./InternationalBanner.vue?vue&type=template&id=3fb58e8e&scoped=true"
import script from "./InternationalBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./InternationalBanner.vue?vue&type=script&setup=true&lang=js"
import style0 from "./InternationalBanner.vue?vue&type=style&index=0&id=3fb58e8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb58e8e",
  null
  
)

export default component.exports